
import { defineComponent, PropType } from 'vue';
import { Files } from '@element-plus/icons-vue';
import type {
  IManageCreateEnclosureListItem,
} from '@/api/project-service/type.d';

export default defineComponent({
  name: 'EnclosurePreview',
  components: {
    [Files.name]: Files,
  },
  props: {
    enclosureList: {
      type: Array as PropType<IManageCreateEnclosureListItem[]>,
      default: () => [],
    },
    size: {
      type: String as PropType<'mini'>,
      default: () => '',
    },
  },
  setup(props) {
    const imgExt = ['.png', '.jpg', '.jpeg', '.bmp', '.gif'];
    const isImage = (file: IManageCreateEnclosureListItem) => {
      const { fileUrl: url } = file;
      return imgExt.includes(url.substring(url.lastIndexOf('.')));
    };

    const previewImg = props.enclosureList
      .filter(file => isImage(file))
      .map(file => file.fileUrl);

    return {
      isImage,
      previewImg,
    };
  },
});
